import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=2cf10dde&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=2cf10dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf10dde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf10dde')) {
      api.createRecord('2cf10dde', component.options)
    } else {
      api.reload('2cf10dde', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=2cf10dde&scoped=true&", function () {
      api.rerender('2cf10dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2L9MoID4sXSvZ/JS/comp/DocBox.vue"
export default component.exports